import React, { useState } from 'react';
import styled from 'styled-components';

import { Datepicker } from '../components/Datepicker';

function StandaloneDatepicker() {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    function onChange(start, end) {
        setStartDate(start);
        setEndDate(end);
    }

    function onApply() {
        const event = new Event('nojesresor/hotels/search');

        event.start = startDate;
        event.end = endDate;

        document.dispatchEvent(event);
    }

    function onClear() {
        setStartDate(null);
        setEndDate(null);

        const event = new Event('nojesresor/hotels/search');

        event.start = null;
        event.end = null;

        document.dispatchEvent(event);
    }

    return (
        <Wrapper>
            <Datepicker
                startDate={startDate}
                endDate={endDate}
                hideClearButton={true}
                onChange={onChange}
                onClear={onClear}
            />
            <div className="datefilter-buttons">
                <button
                    className="clear-dates pill-button"
                    onClick={onClear}
                >
                    Rensa datum
                </button>
                <button
                    className="filter-dates pill-button pill-button--orange"
                    onClick={onApply}
                >
                    Visa resultat
                </button>
            </div>
        </Wrapper>
    );
}

export { StandaloneDatepicker };

const Wrapper = styled.div`
    .datefilter-buttons {
        display: flex;
        gap: 10px;
        width: 70%;
        margin: 24px auto 0;
        @media screen and (max-width: 767px) {
            width: 100%;
            flex-wrap: wrap;
            padding: 0 4%;
            gap: 18px;
        }
    }

    .clear-dates {
        display: block;
        cursor: pointer;
        text-align: center;
        width: 100%;
        border: none;
        color: #140f1f;
        font-size: 16px;
        background: #ececec;

        &:hover {
            background-color: #dbdbdb;
        }
    }

    .filter-dates {
        padding: 18px 0;
        font-size: 16px;
        height: 67px;
    }
`;
